export default __webpack_public_path__ + "static/media/_V6C2465 copy.60595682.jpg";